import type { AppState, GetterClass } from '../../../models'

export class MenuCollapsedGetter implements GetterClass {
  static execute(this: void, state: AppState): boolean {
    return state.menuCollapsed
  }
}
